import './UserProfileApp.less';
import React, {useState, useEffect, useContext} from 'react';
import {useParams} from 'react-router-dom';
import useUser from "../../hooks/useUser";
import LoadingPlaceholder from "../../components/loading-placeholder/LoadingPlaceholder";
import UserAvatar from "../../widgets/user-avatar/UserAvatar";
import DraftView from "../../components/draft-view/DraftView";
import {jsonToObject} from "../../../bootstrap/utils/json";
import __ from "../../i18n";


export default function UserProfileApp() {

    const id = parseInt(useParams().id);

    const [user, refs, isLoading] = useUser(id, ['image']);

    if (isLoading) {
        return <LoadingPlaceholder/>;
    }

    const avatarImage = refs.images.find(t => t.id === user.avatar_image_id);

    return <div className="user-profile-app">
        <div className="inner">
            <div className="header">
                <UserAvatar image={avatarImage}/>
                <div className="user-info">
                    <h2 className="full-name">{user.full_name}</h2>
                    {
                        user.title &&
                        <div className="title">{user.title}</div>
                    }
                </div>
            </div>
            {
                user.introduction !== null &&
                <div className="introduction">
                    <h3 className="title">{__('Introduction')}</h3>
                    <DraftView contentState={jsonToObject(user.introduction)}/>
                </div>
            }
        </div>
    </div>;
}
